import { BsStarFill, BsStarHalf } from "react-icons/bs";
export const TopRecipesList = [
  {
    image:
      "https://pinchofyum.com/wp-content/uploads/Chocolate-Chip-Cookies-800x800.jpg",
    title: "The Best Soft Chocolate Chip Cookies",
    review: "1624 REVIEWS / 4.5 AVERAGE",
    star: (
      <>
        <BsStarFill />
        <BsStarFill />
        <BsStarFill />
        <BsStarFill />
        <BsStarHalf />
      </>
    ),
  },
  {
    image: "https://pinchofyum.com/wp-content/uploads/Sunday-Chili-800x800.jpg",
    title: "The Best Sunday Chili",
    review: "104 REVIEWS / 5 AVERAGE",
    star: (
      <>
        <BsStarFill />
        <BsStarFill />
        <BsStarFill />
        <BsStarFill />
        <BsStarFill />
      </>
    ),
  },
  {
    image:
      "https://pinchofyum.com/wp-content/uploads/Miracle-No-Knead-Bread-3-2-800x800.jpg",
    title: "Miracle No Knead Bread",
    review: "411 REVIEWS / 5 AVERAGE",
    star: (
      <>
        <BsStarFill />
        <BsStarFill />
        <BsStarFill />
        <BsStarFill />
        <BsStarFill />
      </>
    ),
  },
  {
    image:
      "https://pinchofyum.com/wp-content/uploads/Baked-Chicken-Meatball-Feature-1-960x960.jpg",
    title: "Best Anytime Baked Chicken Meatballs",
    review: "665 REVIEWS / 5 AVERAGE",
    star: (
      <>
        <BsStarFill />
        <BsStarFill />
        <BsStarFill />
        <BsStarFill />
        <BsStarFill />
      </>
    ),
  },
  {
    image:
      "https://pinchofyum.com/wp-content/uploads/Chicken-Tinga-Tacos-6-800x800.jpg",
    title: "The Best Chicken Tinga Tacos",
    review: "162 REVIEWS / 4.5 AVERAGE",
    star: (
      <>
        <BsStarFill />
        <BsStarFill />
        <BsStarFill />
        <BsStarFill />
        <BsStarHalf />
      </>
    ),
  },
  {
    image:
      "https://pinchofyum.com/wp-content/uploads/Crockpot-Lentil-Soup-3-Homepage-800x800.jpg",
    title: "  The Best Detox Crockpot Lentil Soup",
    review: "624 REVIEWS / 5 AVERAGE",
    star: (
      <>
        <BsStarFill />
        <BsStarFill />
        <BsStarFill />
        <BsStarFill />
        <BsStarFill />
      </>
    ),
  },
  {
    image:
      "https://pinchofyum.com/wp-content/uploads/vegetarian-shepherds-pie-800x800.jpg",
    title: "Vegetarian Shepherd’s Pie",
    review: "240 REVIEWS / 4.5 AVERAGE",
    star: (
      <>
        <BsStarFill />
        <BsStarFill />
        <BsStarFill />
        <BsStarFill />
        <BsStarHalf />
      </>
    ),
  },
  {
    image:
      "https://pinchofyum.com/wp-content/uploads/Fruit-Pizza-Design-1-800x800.jpg",
    title: "Fruit Pizza",
    review: "164 REVIEWS / 5 AVERAGE",
    star: (
      <>
        <BsStarFill />
        <BsStarFill />
        <BsStarFill />
        <BsStarFill />
        <BsStarFill />
      </>
    ),
  },
  {
    image:
      "https://pinchofyum.com/wp-content/uploads/Taking-a-Bite-of-Blueberry-Pancakes-800x800.jpg",
    title: "Fluffiest Blueberry Pancakes",
    review: "629 REVIEWS / 4.5 AVERAGE",
    star: (
      <>
        <BsStarFill />
        <BsStarFill />
        <BsStarFill />
        <BsStarFill />
        <BsStarHalf />
      </>
    ),
  },
  
];
